{
  "name": "@mirai/core",
  "version": "0.4.704",
  "source": "src/index.js",
  "files": [
    "build"
  ],
  "repository": "https://gitlab.com/miraicorp/dev/frontend/core",
  "author": "JΛVI <hello@soyjavi.com>",
  "license": "MIT",
  "scripts": {
    "setup": "rm -rf node_modules && rm -rf yarn.lock && yarn install --force",
    "start": "node scripts/start.js development",
    "build:npm": "node scripts/build.js",
    "build:bundle": "node scripts/bundle.js",
    "build:stats": "source-map-explorer 'dist/**/*.js'",
    "lint": "eslint --cache --fix --format codeframe --ext .jsx,.js src",
    "test": "node scripts/test.js --watchAll=false --silent --runInBand",
    "test:coverage": "node scripts/test.js --coverage --coverageReporters=text --detectOpenHandles --forceExit --silent",
    "test:watch": "node scripts/test.js --watch",
    "test:e2e": "yarn playwright test --ui",
    "test:e2e:ci": "CI=true yarn playwright test",
    "test:e2e:docker:ci": "docker build -t playwright-tests . && docker run --shm-size=1gb --rm -v $(pwd)/__tests__:/app/__tests__ -v $(pwd)/test-results:/app/test-results -v $(pwd)/playwright-report:/app/playwright-report playwright-tests yarn test:e2e:ci",
    "test:e2e:recorder": "yarn playwright codegen --device='iPhone 12'",
    "test:e2e:report": "yarn playwright show-report",
    "pipeline": "yarn lint && yarn test",
    "release": "yarn build:npm && yarn version --patch && yarn publish --access public"
  },
  "dependencies": {
    "@mirai/data-sources": "^0.2",
    "@mirai/icons": "^0.1",
    "@mirai/locale": "^0.3",
    "@mirai/services": "^0.3",
    "@mirai/ui": "^2.1",
    "mixpanel-browser": "^2.74.0",
    "prop-types": "^15.8.1",
    "react": "^19.1.0",
    "react-dom": "^19.1.0",
    "socket.io-client": "^4.7.2"
  },
  "devDependencies": {
    "@babel/cli": "7.29.7",
    "@babel/core": "7.29.7",
    "@babel/preset-env": "7.29.7",
    "@babel/preset-react": "7.27.1",
    "@mirai/eslint": "0.1.13",
    "@parcel/transformer-inline-string": "2.15.2",
    "@playwright/test": "^1.54.1",
    "@testing-library/dom": "^10.4.0",
    "@testing-library/react": "16.3.0",
    "babel-jest": "^29.7.0",
    "dotenv": "^16.6.1",
    "dotenv-expand": "^11.0.7",
    "http-server": "^14.1.1",
    "identity-obj-proxy": "^3.0.0",
    "jest": "^29.7.0",
    "jest-environment-jsdom": "^29.7.0",
    "jest-fetch-mock": "^3.0.3",
    "parcel": "2.15.2",
    "process": "0.11.10",
    "serve": "14.2.4",
    "source-map-explorer": "2.5.3",
    "wouter": "^2.8.1"
  },
  "engines": {
    "node": ">=22.11.0"
  },
  "resolutions": {
    "@babel/helper-compilation-targets": "7.29.7",
    "@mirai/data-sources": "^0.2",
    "@mirai/icons": "^0.1",
    "@mirai/locale": "^0.3",
    "@mirai/services": "^0.3",
    "@mirai/ui": "^2.1",
    "react": "^19.1.0",
    "react-dom": "^19.1.0",
    "use-sync-external-store": "1.5.0"
  },
  "browserslist": [
    ">0.2%",
    "not dead",
    "not op_mini all"
  ],
  "targets": {
    "default": {
      "context": "browser",
      "includeNodeModules": true
    }
  },
  "@parcel/transformer-js": {
    "inlineEnvironment": true
  },
  "alias": {
    "buffer": false
  }
}
